module.exports = __webpack_public_path__ + "static/media/_gibraltar.c0e73633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_gibraltar.svg
// module id = 2324
// module chunks = 7